import { Directive, HostListener } from '@angular/core';
import { stripPhoneExtension } from '../helpers/phone-number';

@Directive({
  selector: '[phoneNumber]',
})
export class PhoneNumberDirective {
  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
  ];

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): void {
    if (
      this.navigationKeys.includes(e.key) ||
      (e.key === 'a' && (e.ctrlKey || e.metaKey)) ||
      (e.key === 'c' && (e.ctrlKey || e.metaKey)) ||
      (e.key === 'v' && (e.ctrlKey || e.metaKey)) ||
      (e.key === 'x' && (e.ctrlKey || e.metaKey))
    ) {
      return;
    }

    if (e.key === '+') {
      const input = e.target as HTMLInputElement;
      if (input?.selectionStart === 0 && !input?.value?.startsWith('+')) {
        return;
      }
      e.preventDefault();
      return;
    }

    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(e: ClipboardEvent): void {
    const pastedText = e.clipboardData?.getData('text/plain') || '';
    // Drop an extension first, or its digits get glued onto the number
    const sanitized = stripPhoneExtension(pastedText).replace(/[^\d+]/g, '');
    // Ensure only one + at the start
    const cleaned = sanitized.startsWith('+')
      ? '+' + sanitized.substring(1).replace(/\+/g, '')
      : sanitized.replace(/\+/g, '');

    if (cleaned !== pastedText) {
      e.preventDefault();
      const input = e.target as HTMLInputElement;
      const start = input.selectionStart || 0;
      const end = input.selectionEnd || 0;
      const currentValue = input.value;
      const newValue = currentValue.substring(0, start) + cleaned + currentValue.substring(end);
      input.value = newValue;
      input.dispatchEvent(new Event('input'));
    }
  }
}
